// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 343 ? "6edf0643" : chunkId) + "." + {"343":"df995cd84ed9752b","7200":"3e0e6707fd1c7281"}[chunkId] + ".js";
};